<template>
  <div>
    <v-btn
      :color="itens_selecionados.produtos_mp.length == 0 ? 'white' : 'primary'"
      :disabled="itens_selecionados.produtos_mp.length == 0"
      @click.prevent="abrirDialog()"
    >
      <v-icon left>mdi-content-save</v-icon>
      Salvar
    </v-btn>
    <SysDialog
      v-model="dialog"
      titulo="Informe o nome da categoria"
      @click:primary="save()"
      ocultar_botao_fechar
      content-class="bra-20"
    >
      <v-text-field
        v-model="nome_categoria"
        outlined
        single-line
        append-icon="mdi-magnify"
        label="Nome da Categoria"
        class="mx-4 mt-8 mb-3"
        :error-messages="nomeCategoriaErrors"
        @input="$v.nome_categoria.$touch()"
        @blur="$v.nome_categoria.$touch()"
      ></v-text-field>
    </SysDialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import CategoriaMateriaPrimaAPI from "@/api/categoriaCompraMateriaPrima";

export default {
  components: { SysDialog },
  props: {
    itens_selecionados: {
      type: Object,
      required: true,
    },
  },
  validations: {
    nome_categoria: {
      required,
    },
  },
  data() {
    return {
      dialog: false,
      nome_categoria: "",
    };
  },
  computed: {
    nomeCategoriaErrors() {
      const errors = [];
      if (!this.$v.nome_categoria.$dirty) return errors;
      !this.$v.nome_categoria.required && errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  methods: {
    abrirDialog() {
      this.nome_categoria = "";
      this.dialog = true;
    },
    fecharDialog() {
      this.dialog = false;
    },
    save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = {
          nome_categoria: this.nome_categoria,
          ...this.itens_selecionados,
        };
        this.$store.dispatch(
          "loading/addRequisicao",
          CategoriaMateriaPrimaAPI.storeRelacionamentosMPPA(headers, params)
            .then((response) => {
              const { token } = response.data;
              localStorage.setItem("token", token);
              this.fecharDialog();
              this.$emit("atualizar-tela-categoria");
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
  },
};
</script>

<style>
</style>
